import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { closingLines } from '../data/offer';
export function ClosingSection() {
  return <section className="border-y border-energy/15 bg-navy-light py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-38" data-mp="12su1nsplz4ev">
      <div className="mx-auto max-w-4xl px-4" data-id="element-39" data-mp="xt91xg2m6s13">
        <h2 id="closing-title" className="text-balance text-center text-3xl font-extrabold uppercase leading-tight tracking-tight text-cream sm:text-4xl" data-id="element-40" data-mp="xsfqw2wmhgd5">
          Basta improvvisare. <span className="text-energy" data-id="element-41" data-mp="17qvlwgyrt9rx">Inizia a insegnare le energie rinnovabili con chiarezza.</span>
        </h2>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-42" data-mp="1litn85m8q1dj">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-xl border-l-4 border-energy bg-navy-card px-4 py-3 text-sm font-semibold text-cream" data-id="element-43" data-mp="1hi9pp0xr8vqv" data-mpi={index}>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-aqua" aria-hidden="true" data-id="element-44" data-mp="2cas00wnsoido" />
              {line}
            </motion.li>)}
        </ul>
      </div>
    </section>;
}